import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BannerHomeResponse, BannerRequest, BannerResponse } from "app/shared/models/ei-models";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { BaseService } from "../../core";

@Injectable({ providedIn: 'root' })
export class BannerService extends BaseService {
    private controllerEndpoint = environment.urlEdducaImobApi.concat('EdducaImobCore/Banner/');

    constructor(private httpClient: HttpClient) {
        super();
    }

    listarTodos(): Observable<BannerResponse[]> {
        return this.httpClient.get<BannerResponse[]>(
            this.controllerEndpoint.concat('ListarTodos'),
            { headers: this.getHeader(true) }
        );
    }

    obterPorId(id: number): Observable<BannerResponse> {
        return this.httpClient.get<BannerResponse>(
            this.controllerEndpoint.concat('Obter/', id.toString()),
            { headers: this.getHeader(true) }
        );
    }

    criar(payload: BannerRequest): Observable<BannerResponse> {
        return this.httpClient.post<BannerResponse>(
            this.controllerEndpoint.concat('Criar'),
            payload,
            { headers: this.getHeader(true) }
        );
    }

    atualizar(id: number, payload: BannerRequest): Observable<BannerResponse> {
        return this.httpClient.put<BannerResponse>(
            this.controllerEndpoint.concat('Atualizar/', id.toString()),
            payload,
            { headers: this.getHeader(true) }
        );
    }

    remover(id: number): Observable<void> {
        return this.httpClient.delete<void>(
            this.controllerEndpoint.concat('Remover/', id.toString()),
            { headers: this.getHeader(true) }
        );
    }

    listarParaHome(): Observable<BannerHomeResponse[]> {
        return this.httpClient.get<BannerHomeResponse[]>(
            this.controllerEndpoint.concat('ListarParaHome'),
            { headers: this.getHeader(false) }
        );
    }
}
